import React, { useMemo } from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import { useParams } from 'react-router';
import block from 'bem-cn';

import { useAppSelector } from 'shared/hooks';

import Item from './Item';

// import { ITableProps } from './types';
import './Table.scss';

const b = block('statistic-table-mobile');

const Table = ({ data, type }) => {
  const locale = useAppSelector(state => state.locale.locale, shallowEqual);

  const itemsElements = useMemo(
    () =>
      data?.map((t, i) => (
        <div key={t.number} className={b('item')}>
          <Item item={t} type={type} />
        </div>
      )),
    [data, type],
  );

  return (
    <div className={b()}>
      {/* <div className={b('header')}>
        <div className={b('header-item')}>{locale.number}</div>
        <div className={b('header-item')}>{locale.id}</div>
        <div className={b('header-item')}>{locale.username}</div>
        <div className={b('header-item')}>{locale.netwin}</div>
      </div> */}
      {itemsElements?.length ? itemsElements : <div className={b('empty')}>{locale.noResultsFound}</div>}
    </div>
  );
};

export default Table;
